import { type WHEEL_PRIZES } from '@/entities/wheel/model/wheel.types';

import { type WheelSector } from '@/shared/ui/wheel_new/types';

import { api } from '../api';

export const getWheelPrizes = async (): Promise<WheelSector<WHEEL_PRIZES>[]> => {
  const res = await api.get('/v1/wheel');
  return res.data;
};
